import React from "react";
import { transformationFunctions } from "../../../utils";
import MapperFunction from "./MapperFunction";

const TargetValueSection = (props) => {
  const {
    forFileNameConfigure = false,
    fields,
    setClickToSelect,
    clickToSelect,
    setFieldArrayName,
    parameterTypes,
    valueError,
    headerError,
    isSplitConfigured,
    deserializeHeaderMapJson,
  } = props;
  return (
    <div className="mapper-target-container mt-30 ml-3">
      <MapperFunction
        deserializeHeaderMapJson={deserializeHeaderMapJson}
        isSplitConfigured={isSplitConfigured}
        forFileNameConfigure={forFileNameConfigure}
        functionList={transformationFunctions || []}
        fields={fields}
        isValue={true}
        parameterTypes={parameterTypes}
        setClickToSelect={setClickToSelect}
        clickToSelect={clickToSelect}
        setFieldArrayName={setFieldArrayName}
        headerError={headerError}
        valueError={valueError}
      />
    </div>
  );
};

export default TargetValueSection;
